import { IMS_SUMMARY_DATA, IMS_UPLOAD_HISTORY_DATA, LOADER_STATUS, SAVE_TOTAL_PAGES_UPLOAD_HISTORY, SET_IMS_FETCH_HISTORY, SET_IMS_FETCH_HISTORY_PAGE_NO } from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  imsFetchHistory:[],
  imsFetchHistoryTotalCount:0,
  imsFetchHistoryPageNo:1,
  imsUploadHistoryData:[],
  imsSummaryData:[],
  totalPagesUploadHistory: 1,
};
/* eslint-disable default-case, no-param-reassign */
const imsPrepareReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_IMS_FETCH_HISTORY:
      return {
        ...state,
        imsFetchHistory: action.payload,
        imsFetchHistoryTotalCount:action.recordCount
      };
    case SET_IMS_FETCH_HISTORY_PAGE_NO:
        return {
          ...state,
          imsFetchHistoryPageNo:action.imsFetchHistoryPageNo
        };
        case IMS_UPLOAD_HISTORY_DATA:
          return {
            ...state,
            imsUploadHistoryData:action.imsUploadHistoryData
          };
          case IMS_SUMMARY_DATA:
          return {
            ...state,
            imsSummaryData:action.imsSummaryData
          };
          case SAVE_TOTAL_PAGES_UPLOAD_HISTORY:
      return {
        ...state,
        totalPagesUploadHistory: action.pages,
      };
    default:
      return state;
  }
};

export default imsPrepareReducer;